import { IInvoice } from '../interfaces';
import { usesInvoierCheckout } from './paymentProvider';

export type CheckoutFlow = 'resurs' | 'invoier' | 'unavailable';

/**
 * The backend's invoice type is `standard`; `service` is the payment provider
 * such invoices carry, and is accepted too.
 */
export function isStandardInvoice(invoiceType: string | null | undefined): boolean {
    return invoiceType === 'standard' || invoiceType === 'service';
}

/**
 * Which checkout the customer gets. A standard invoice is approved on the same
 * page as the Invoier-family financiers, just without payment options.
 */
export function checkoutFlow(invoice: IInvoice): CheckoutFlow {
    const provider = invoice.payment_provider?.toLowerCase?.() ?? '';
    if (provider === 'resurs') return 'resurs';
    if (usesInvoierCheckout(provider) || isStandardInvoice(invoice.invoice_type)) {
        return 'invoier';
    }
    return 'unavailable';
}
